import * as THREE from 'three';

import { Model } from '../lib/Model';

export class SceneAmbientLight extends Model {
    constructor(viewer) {
        super('ALight', viewer);
        this.model = new THREE.AmbientLight(
            0x808080,
            1
        );
    }

    // eslint-disable-next-line class-methods-use-this
    animate() {}
}
